<script lang="ts">
    import {Component, Vue, Prop, toNative} from 'vue-facing-decorator'

    @Component
    export class ValidateSearchOptionsMixin extends Vue {
        @Prop({default: false, type: Boolean}) chooseAgentDialogValid
        @Prop({default: false, type: Boolean}) chooseAgentDialogValidate

        _formValid = null

        get summaryValid() {
            if (!this.chooseAgentDialogValidate) {
                return this._formValid
            }
            const chooseAgentDialogValid =
                !!persistentStore.selectedPrivateClient ||
                !!persistentStore.selectedCompanyAndAgent ||
                !!this.chooseAgentDialogValid
            return !!chooseAgentDialogValid && !!this._formValid
        }
    }

    export default toNative(ValidateSearchOptionsMixin)
</script>
